import { render, staticRenderFns } from "./FaqAjudaResumo.vue?vue&type=template&id=dc21b198&"
import script from "./FaqAjudaResumo.vue?vue&type=script&lang=js&"
export * from "./FaqAjudaResumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports